import { TagPlace } from 'components/Common/Labels/OfferUrgencyCountdownLabel'
import { DAYS_TO_BOOK as BEDBANK_DAYS_TO_BOOK } from 'constants/bedbank'
import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { useMemo } from 'react'

export type CountdownTagOptions = {
  tagPlaceId: TagPlace
  showTag: boolean
  showWithinXDays: number
}

export type CountdownTagProps = {
  tagPlaceId: TagPlace
  overrideShowWithinXDays?: number
  offerId?: string
}

const DEFAULT_DAYS_TO_BOOK = 4

const useCountdownTagOptions = (props: CountdownTagProps): CountdownTagOptions => {
  const forceShowOfferUrgencyCountdownLabel = Boolean(useOptimizelyExperiment(OptimizelyExperiments.growthShowOfferUrgencyCountdownLabel))

  return useMemo(() => {
    let showWithinXDays = DEFAULT_DAYS_TO_BOOK

    if (props.tagPlaceId == 'deals-tile-item') {
      showWithinXDays = 7
    }

    if (props.tagPlaceId == 'tour-v2-urgency-tags') {
      showWithinXDays = 5
    }

    if (props.tagPlaceId == 'bedbank-offer-intro') {
      showWithinXDays = BEDBANK_DAYS_TO_BOOK
    }

    showWithinXDays = props.overrideShowWithinXDays ?? showWithinXDays

    // temp debug: very large upper limit
    const FORCE_SHOW_WITHIN_UPPER_LIMIT = 99999999999 // 90

    return {
      tagPlaceId: props.tagPlaceId,
      showTag: forceShowOfferUrgencyCountdownLabel,
      showWithinXDays: forceShowOfferUrgencyCountdownLabel ? FORCE_SHOW_WITHIN_UPPER_LIMIT : showWithinXDays,
    }
  }, [props.tagPlaceId, props.overrideShowWithinXDays, forceShowOfferUrgencyCountdownLabel])
}

export default useCountdownTagOptions
